import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";
import useAuth from "@/contexts/auth-context";
import useLanguage from "@/contexts/language-context";
import ROUTE_URLS from "@/constants/route-urls";
import { isPWAStandalone } from "@/utils/environment.utils";

const Home: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isAuthReady, isLoading } = useAuth();
  const { lang } = useLanguage();

  useEffect(() => {
    // Redirecionar se estivermos na rota raiz "/" ou "/:lang"
    const isRootRoute = location.pathname === "/" || /^\/[a-z]{2}$/i.test(location.pathname);
    if (!isRootRoute) return;

    // Aguardar até que a autenticação esteja pronta
    if (!isAuthReady || isLoading) return;

    // Redirecionar baseado no status de autenticação
    if (isAuthenticated) {
      navigate(
        isPWAStandalone() ? ROUTE_URLS.chat(lang) : ROUTE_URLS.serviceDashboard(lang),
        { replace: true }
      );
    } else {
      navigate(ROUTE_URLS.login(lang), { replace: true });
    }
  }, [isAuthenticated, isAuthReady, isLoading, navigate, lang, location.pathname]);

  // Mostrar loading enquanto verifica autenticação
  if (!isAuthReady || isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="var(--full-vh)">
        <CircularProgress size={40} />
      </Box>
    );
  }

  // Se não estiver carregando e auth estiver pronto, não renderizar nada
  // O redirecionamento será feito pelo useEffect
  return null;
};

export default Home;
